import { render, staticRenderFns } from "./ForumPosts.vue?vue&type=template&id=094e3354&scoped=true&"
import script from "./ForumPosts.vue?vue&type=script&lang=js&"
export * from "./ForumPosts.vue?vue&type=script&lang=js&"
import style0 from "./ForumPosts.vue?vue&type=style&index=0&id=094e3354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094e3354",
  null
  
)

export default component.exports